export default {"src":"/_next/static/media/Thursday.a49710c6.svg","height":1214,"width":1300};